export enum BudgetLineType {
    SECTION = 'SECTION',
    ELEMENT = 'ELEMENT',
    COMPONENT_ELEMENT = 'COMPONENT_ELEMENT',
    PAGE_BREAK = 'PAGE_BREAK',
    NOTE = 'NOTE',
}
